<template>
  <div class="container-fluid has-shadow">
    <div class="row footer__top">
      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 m-b-20-xs">
        <img :src="companyProfile.logo_url" width="200" alt="" class="responsive-image">
        <p class="footer__top__section-tagline">{{ companyProfile.bio }}</p>
        <h6 class="footer__top__section-headline">
          {{ $t("footer.keepTouch") }}
        </h6>
        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.twitter_profile != ''" v-bind:href="companyProfile.twitter_profile"><i class="fa fa-twitter fa-2x" aria-hidden="true"></i></a>
        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.linkedin_profile != ''" v-bind:href="companyProfile.linkedin_profile"><i class="fa fa-linkedin fa-2x" aria-hidden="true"></i></a>
        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.facebook_profile != ''" v-bind:href="companyProfile.facebook_profile"><i class="fa fa-facebook-f fa-2x" aria-hidden="true"></i></a>
        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.youtube_profile != ''" v-bind:href="companyProfile.youtube_profile"><i class="fa fa-youtube fa-2x" aria-hidden="true"></i></a>
        <a target="_blank" rel="noopener" class="icon-link" v-if="companyProfile.instagram_profile != ''" v-bind:href="companyProfile.instagram_profile"><i class="fa fa-instagram fa-2x" aria-hidden="true"></i></a>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-6 hidden-xs">
        <ul>
          <li>
            <h6 class="footer__top__section-headline">{{ footerMenu_1.title }}</h6></li>
            <li v-for="menuItem in footerMenu_1.options" :key="menuItem.id">
              <router-link :to=" { path: '/' + $parent.$parent.$i18n.locale + menuItem.url }">
                {{ menuItem.title }}
              </router-link>
            </li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-6 hidden-xs">
        <ul>
          <li>
            <h6 class="footer__top__section-headline">{{ $t("menu.blog") }}</h6></li>
            <li v-for="blog in news.slice(0, 3)" :key="blog.id">
              <router-link v-if="blog.source_url == ''" :to="{ path: '/' + $parent.$parent.$i18n.locale + '/blog/' + blog.slug }">
                {{ blog.title }}
              </router-link>
              <a target="_blank" rel="noopener" v-if="blog.source_url != ''" :href="blog.source_url">
                {{ blog.title }}
              </a>
          </li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
        <ul>
          <li>
            <h6 class="footer__top__section-headline">{{ $t("menu.contactUs") }}</h6>
          </li>
          <li>
            <p class="footer__top__section-tagline">{{ companyProfile.address }}</p>
          </li>
          <li style="unicode-bidi: plaintext">{{ companyProfile.phone_number_1 }}</li>
          <li>
            <a target="_blank" rel="noopener" :href="'mailto:' + companyProfile.email" class="button button--link button--link--peach">
              <span class="button--link__text button--link--peach__text">{{ companyProfile.email }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: "TopFooter",
	data() {
		return {
			companyProfile: {},
			footerMenu_1: {},
			news: []
		};
	},
	mounted() {
		this.getAll();
	},
	methods: {
		getAll() {
			this.$http
				.get(this.$parent.$parent.$parent.apiURL + "/Companyprofiles")
				.then(function(response) {
					this.companyProfile = response.body[0];
				});
			this.$http
				.post(this.$parent.$parent.$parent.apiURL + "/menus/get-menu?id=3")
				.then(function(response) {
					this.footerMenu_1 = response.body;
				});
			this.$http
				.get(this.$parent.$parent.$parent.apiURL + "/news")
				.then(function(response) {
					this.news = response.body;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/modules/FooterComponents/TopFooter.vue